import Reviews from "../../layouts/Reviews";
import GameReviewTable from "../../components/reviews/GameReviewTable";

export default function GameReviews() {

    const rightContent = (
        <div>
            <GameReviewTable/>
        </div>
    )
    return (
        <div className="game-reviews-page">
            <Reviews rightContent={rightContent}/>
        </div>
    )
}
